import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../data/mock';

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-24 lg:py-32 border-t border-[color:var(--gold-500)]/10">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="mb-16 text-center">
          <p className="text-[11px] tracking-widest-2 text-[color:var(--gold-400)] uppercase mb-4">
            Perguntas Frequentes
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.4rem] text-[color:var(--cream-100)] leading-tight">
            Tire suas{' '}
            <span className="italic text-[color:var(--gold-400)]">dúvidas.</span>
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-[color:var(--gold-500)]/15">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                >
                  <span className="font-serif text-lg md:text-xl text-[color:var(--cream-100)] group-hover:text-[color:var(--gold-400)] transition-colors">
                    {f.q}
                  </span>
                  <span className="text-[color:var(--gold-400)] shrink-0">
                    {isOpen ? <Minus size={20} /> : <Plus size={20} />}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-500 ease-in-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100 pb-6' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="text-[color:var(--cream-100)]/75 leading-relaxed pr-6">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
